import React from "react";

export default function Boton({ accion, texto, change }) {
  if (!texto) texto = "Actualizar"
  const Sboton = {
    marginTop: "15px",
    paddingTop: "5px",
    borderRadius: "5px",
    background: change ? "red" : "gray",
    height: "35px",
    width: "110px",
    textAlign: "center",
    cursor: change ? "pointer" : "not-allowed"
  };

  return (
    <div style={Sboton} onClick={() => { if (change) accion() }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.03)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "";
      }}>
      {texto}
    </div>
  );
}


